import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Image imports
import Lounge1 from '../assets/images/gallery/lounge/1.PNG';
import Lounge2 from '../assets/images/gallery/lounge/2.jpg';
import Lounge3 from '../assets/images/gallery/lounge/3.jpg';
import Lounge4 from '../assets/images/gallery/lounge/4.jpg';
import Lounge5 from '../assets/images/gallery/lounge/5.jpg';
import Lounge6 from '../assets/images/gallery/lounge/6.jpg';
import Lounge7 from '../assets/images/gallery/lounge/7.jpg';
import Lounge8 from '../assets/images/gallery/lounge/8.jpg';
import Bunks1 from '../assets/images/gallery/bunks/1.jpg';
import Bunks2 from '../assets/images/gallery/bunks/2.jpg';
import Bunks3 from '../assets/images/gallery/bunks/3.jpg';
import Bunks4 from '../assets/images/gallery/bunks/4.jpg';
import Bunks5 from '../assets/images/gallery/bunks/5.jpg';
import Rooms1 from '../assets/images/gallery/rooms/1.jpg';
import Rooms2 from '../assets/images/gallery/rooms/2.jpg';
import Rooms3 from '../assets/images/gallery/rooms/3.jpg';
import Rooms4 from '../assets/images/gallery/rooms/4.jpg';
import Rooms5 from '../assets/images/gallery/rooms/14.jpg';
import Rooms6 from '../assets/images/gallery/rooms/6.jpg';
import Rooms7 from '../assets/images/gallery/rooms/7.jpg';
import Rooms8 from '../assets/images/gallery/rooms/8.jpg';
import Rooms9 from '../assets/images/gallery/rooms/9.jpg';
import Rooms10 from '../assets/images/gallery/rooms/10.jpg';
import Rooms11 from '../assets/images/gallery/rooms/11.jpg';
import Rooms12 from '../assets/images/gallery/rooms/12.jpg';
import Rooms13 from '../assets/images/gallery/rooms/13.jpg';
import Rooms14 from '../assets/images/gallery/rooms/14.jpg';
import Rooms15 from '../assets/images/gallery/rooms/15.jpg';
import Rooms16 from '../assets/images/gallery/rooms/16.jpg';
import Food1 from '../assets/images/gallery/food/1.jpg';
import Food2 from '../assets/images/gallery/food/2.jpg';
import Food3 from '../assets/images/gallery/food/3.jpg';
import Food4 from '../assets/images/gallery/food/4.jpg';
import Spabath1 from '../assets/images/gallery/spabath/1.jpg';
import Spabath2 from '../assets/images/gallery/spabath/2.jpg';
import Spabath3 from '../assets/images/gallery/spabath/3.jpg';
import Spabath4 from '../assets/images/gallery/spabath/18.jpg';
import Spabath5 from '../assets/images/gallery/spabath/5.jpg';
import Spabath6 from '../assets/images/gallery/spabath/6.jpg';
import Spabath7 from '../assets/images/gallery/spabath/7.jpg';
import Spabath8 from '../assets/images/gallery/spabath/8.jpg';
import Spabath9 from '../assets/images/gallery/spabath/9.jpg';
import Spabath10 from '../assets/images/gallery/spabath/10.jpg';
import Spabath11 from '../assets/images/gallery/spabath/11.jpg';
import Spabath12 from '../assets/images/gallery/spabath/12.jpg';
import Spabath13 from '../assets/images/gallery/spabath/13.jpg';
import Spabath14 from '../assets/images/gallery/spabath/14.jpg';
import Spabath15 from '../assets/images/gallery/spabath/15.jpg';
import Spabath16 from '../assets/images/gallery/spabath/16.jpg';
import Spabath17 from '../assets/images/gallery/spabath/17.jpg';

// Header image
import headerImage from '../assets/images/rooms/header.jpg';

// External stylesheets from Aboutus component
const stylesheets = [
  'https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap',
  'https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap',
  'https://fonts.googleapis.com/css2?family=Yellowtail&display=swap',
  '/pettipetti/css/bootstrap.min.css',
  '/bbmirissa/css/style.css',
  '/pettipetti/css/secondary/style.css',
  '/pettipetti/css/vendors.min.css',
  '/pettipetti/css/custom.css',
];

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleItems, setVisibleItems] = useState(15);

  // Navbar scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY;
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        if (scroll > 0) {
          navbar.style.backgroundColor = '#1a3c34';
        } else {
          navbar.style.backgroundColor = 'transparent';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const galleryItems = useMemo(() => [
    // Lounge Images
    { category: 'lounge', image: Lounge1, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge2, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge3, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge4, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge5, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge6, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge7, alt: 'Lounge', title: 'Lounge' },
    { category: 'lounge', image: Lounge8, alt: 'Lounge', title: 'Lounge' },

    // Bunks Images
    { category: 'bunks', image: Bunks1, alt: 'Bunks', title: 'Bunks' },
    { category: 'bunks', image: Bunks2, alt: 'Bunks', title: 'Bunks' },
    { category: 'bunks', image: Bunks3, alt: 'Bunks', title: 'Bunks' },
    { category: 'bunks', image: Bunks4, alt: 'Bunks', title: 'Bunks' },
    { category: 'bunks', image: Bunks5, alt: 'Bunks', title: 'Bunks' },

    // Rooms Images
    { category: 'rooms', image: Rooms1, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms2, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms3, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms4, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms5, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms6, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms7, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms8, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms9, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms10, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms11, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms12, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms13, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms14, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms15, alt: 'Room', title: 'Room' },
    { category: 'rooms', image: Rooms16, alt: 'Room', title: 'Room' },

    // Food Images
    { category: 'food', image: Food1, alt: 'Food', title: 'Food' },
    { category: 'food', image: Food2, alt: 'Food', title: 'Food' },
    { category: 'food', image: Food3, alt: 'Food', title: 'Food' },
    { category: 'food', image: Food4, alt: 'Food', title: 'Food' },

    // Spa Bath Images
    { category: 'spabath', image: Spabath1, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath2, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath3, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath4, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath5, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath6, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath7, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath8, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath9, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath10, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath11, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath12, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath13, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath14, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath15, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath16, alt: 'Spa Bath', title: 'Spa Bath' },
    { category: 'spabath', image: Spabath17, alt: 'Spa Bath', title: 'Spa Bath' },
  ], []);

  const filteredItems = useMemo(() => 
    filter === 'all' ? galleryItems : galleryItems.filter(item => item.category === filter),
    [filter, galleryItems]
  );

  const displayedItems = filteredItems.slice(0, visibleItems);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        setVisibleItems(prev => Math.min(prev + 10, filteredItems.length));
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [filteredItems.length]);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = '';
  };

  return (
    <div className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox">
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#1a3c34" />
        <title>Gallery | Banana Bunks Mirissa | Oryza Leisure</title>
        <meta name="author" content="Ollcode" />
        <meta name="description" content="Explore the vibrant and cozy spaces at Banana Bunks Mirissa, featuring lounges, bunks, rooms, dining, and spa baths." />
        <meta name="keywords" content="hotel, hostel, bunks, rooms, dining, spa bath, lounge, vacation, mirissa, banana bunks, oryza leisure" />
        {stylesheets.map((href, index) => (
          <link key={index} rel="stylesheet" href={href} type="text/css" media="all" />
        ))}
      </Helmet>

      <style>
        {`
           /* Import Yellowtail font from Google Fonts */
          @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

          .hotale-page-title hotale-additional-font {
            font-family: 'Yellowtail', cursive !important;
            font-style: normal !important;
            font-weight: 400 !important;
            color: rgb(255, 255, 255) !important;
            font-size: 80px !important;
            line-height: 96px !important;
          }

          /* Mobile overrides for font styles */
          @media (max-width: 375px) {
            .hotale-page-title hotale-additional-font {
              font-size: 35px !important; /* Smaller font size for mobile */
              line-height: 56px !important; /* Smaller line height for mobile */
            }
          }
        `}
      </style>

      <Navbar />

      <main id="main">
        {/* Header Banner */}
        <div className="hotale-page-title-wrap hotale-style-custom hotale-center-align" style={{ backgroundImage: `url(${headerImage})` }}>
          <div className="hotale-header-transparent-substitute"></div>
          <div className="hotale-page-title-overlay"></div>
          <div className="hotale-page-title-container hotale-container">
            <div className="hotale-page-title-content hotale-item-pdlr">
              <h1 className="hotale-page-title hotale-additional-font"><b>Gallery</b></h1>
            </div>
          </div>
        </div>

        {/* Gallery Section with Filter */}
        <section className="gallery-section bbmirissabg_m">
          <div className="filter-container">
            <div className="filter-buttons">
              <button 
                className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All
              </button>
              <button 
                className={`filter-btn ${filter === 'lounge' ? 'active' : ''}`}
                onClick={() => setFilter('lounge')}
              >
                Lounge
              </button>
              <button 
                className={`filter-btn ${filter === 'bunks' ? 'active' : ''}`}
                onClick={() => setFilter('bunks')}
              >
                Bunks
              </button>
              <button 
                className={`filter-btn ${filter === 'rooms' ? 'active' : ''}`}
                onClick={() => setFilter('rooms')}
              >
                Rooms
              </button>
              <button 
                className={`filter-btn ${filter === 'food' ? 'active' : ''}`}
                onClick={() => setFilter('food')}
              >
                Food
              </button>
              <button 
                className={`filter-btn ${filter === 'spabath' ? 'active' : ''}`}
                onClick={() => setFilter('spabath')}
              >
                Spa Bath
              </button>
            </div>
          </div>

          <div className="gallery-masonry">
            {displayedItems.map((item, index) => (
              <div key={index} className="gallery-item">
                <div className="gallery-image-container" onClick={() => openLightbox(item.image)}>
                  <LazyLoadImage
                    src={item.image}
                    alt={item.alt}
                    effect="blur"
                    className="gallery-image"
                  />
                  <div className="image-overlay"></div>
                </div>
              </div>
            ))}
          </div>

          {visibleItems < filteredItems.length && (
            <div className="load-more-container">
              <button
                className="load-more-btn"
                onClick={() => setVisibleItems(prev => Math.min(prev + 10, filteredItems.length))}
              >
                Load More
              </button>
            </div>
          )}
        </section>

        {/* Lightbox for image preview */}
        {selectedImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={e => e.stopPropagation()}>
              <img src={selectedImage} alt="Preview" className="lightbox-image" />
              <button className="close-btn" onClick={closeLightbox}>×</button>
            </div>
          </div>
        )}

        <Footer />
      </main>

      <style jsx>{`
        /* Global Styles to Prevent Horizontal Scrolling */
        html, body {
          overflow-x: hidden;
          width: 100%;
          position: relative;
        }
        
        /* Gallery Section Styles */
        .gallery-section {
          background-color: #f5f5f5; /* Fallback in case bbmirissabg_m is not defined */
          padding: 3rem 0;
          width: 100%;
          box-sizing: border-box;
        }
        
        .filter-container {
          max-width: 100%;
          margin: 0 auto;
          padding: 0 1rem;
          box-sizing: border-box;
        }
        
        .filter-buttons {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 2rem;
          width: 100%;
          box-sizing: border-box;
        }
        
        .filter-btn {
          color: #eeb85e;
          background: none;
          border: none;
          font-size: 1.2rem;
          text-transform: capitalize;
          cursor: pointer;
          padding: 0.5rem 1rem;
          transition: all 0.3s ease;
          position: relative;
        }
        
        .filter-btn.active {
          color: #1c1c1cff;
        }
        
        .filter-btn.active::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -3px;
          width: 100%;
          height: 2px;
          background-color: #eeb85e;
        }
        
        .filter-btn:hover {
          color: #1c1c1cff;
        }
        
        /* Masonry Gallery Styles */
        .gallery-masonry {
          max-width: 100%;
          margin: 0 auto;
          padding: 0 1rem;
          column-count: 3;
          column-gap: 1.5rem;
          box-sizing: border-box;
        }
        
        .gallery-item {
          break-inside: avoid;
          margin-bottom: 1.5rem;
          border-radius: 8px;
          overflow: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        
        .gallery-image-container {
          position: relative;
          overflow: hidden;
          cursor: pointer;
          width: 100%;
          display: block;
        }
        
        .gallery-image {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.3s ease;
        }
        
        .gallery-image-container:hover .gallery-image {
          transform: scale(1.05);
        }
        
        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0);
          transition: background-color 0.3s ease;
        }
        
        .gallery-image-container:hover .image-overlay {
          background-color: rgba(0, 0, 0, 0.2);
        }
        
        /* Load More Button */
        .load-more-container {
          text-align: center;
          margin-top: 2rem;
          width: 100%;
          box-sizing: border-box;
        }
        
        .load-more-btn {
          background-color: #1a3c34;
          color: white;
          border: none;
          padding: 0.75rem 2rem;
          font-size: 1rem;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        
        .load-more-btn:hover {
          background-color: #4a7c59;
        }
        
        /* Lightbox Styles */
        .lightbox {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        
        .lightbox-content {
          position: relative;
          max-width: 90%;
          max-height: 90vh;
        }
        
        .lightbox-image {
          max-width: 100%;
          max-height: 90vh;
          border-radius: 4px;
        }
        
        .close-btn {
          position: absolute;
          top: -40px;
          right: -40px;
          color: white;
          font-size: 2rem;
          background: none;
          border: none;
          cursor: pointer;
        }
        
        /* Responsive Styles */
        @media (max-width: 992px) {
          .gallery-masonry {
            column-count: 2;
          }
        }
        
        @media (max-width: 768px) {
          .filter-buttons {
            gap: 0.5rem;
            justify-content: flex-start;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            flex-wrap: nowrap;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none; /* Firefox */
          }
          
          .filter-buttons::-webkit-scrollbar {
            display: none; /* Chrome, Safari, Edge */
          }
          
          .filter-btn {
            font-size: 0.9rem;
            padding: 0.4rem 0.6rem;
            white-space: nowrap;
          }
          
          .close-btn {
            top: -30px;
            right: 0;
          }
        }
        
        @media (max-width: 576px) {
          .gallery-page {
            overflow-x: hidden;
            width: 100%;
          }
          
          .gallery-masonry {
            column-count: 1;
            padding: 0 0.5rem;
          }
          
          .filter-container {
            padding: 0 0.5rem;
          }
          
          .filter-buttons {
            margin-bottom: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Gallery;